module.exports = __webpack_public_path__ + "static/img/rank_5.49890da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_5.png
// module id = 9Cng
// module chunks = 0